import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WebdokuService } from '../web-doku/webdoku.service';
import { DocumentService } from '../shared/services/document.service';
import { DocumentHistoryResolved } from '../shared/models/document-history-resolved';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentHistoryResolver  {
  private webDokuService = inject(WebdokuService);
  private documentService = inject(DocumentService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DocumentHistoryResolved> {
    const wd = route.paramMap.get('wd') ?? '';
    const docid = route.paramMap.get('docid') ?? '';

    console.log(`document history resolve for ${docid}`)

    return this.webDokuService.selectWebDoku(wd).pipe(
      switchMap((wdSelectOk) => this.getDocumentHistory(wdSelectOk, docid))
    );
  }

  getDocumentHistory(selectWdOk: boolean, docid: string): Observable<DocumentHistoryResolved> {
    if (!selectWdOk) {
      return of({
        documentHistory: undefined,
        docId: docid,
        error: new Error(`wd not selectable`)
      });
    }
    return this.documentService.getDocumentHistory(docid)
      .pipe(
        map(documentHistory => ({documentHistory: documentHistory, docId: docid})),
        catchError((err) => of({
          documentHistory: undefined,
          docId: docid,
          error: err
        }))
      );
  }
}
